type Review = {
    name: string
    rating: number
    text: string
}

export const reviews: Review[] = [
    {
        rating: 5,
        text: 'As a tool for understanding your financial situation and your borrowing power I rate this app as an honest and supportive platform. Top rated in my opinion and not biased about reality in money situation answers.',
        name: 'Mark',
    },

    {
        rating: 5,
        text: "TotallyMoney has helped me build up my extremely low credit rating to satisfactory. I would recommend anyone who felt that gaining credit was out of their league. It's still #babysteps but I am willing to continue the journey. Thank you again TotallyMoney.",
        name: 'Abeena',
    },

    {
        rating: 4,
        text: 'TotallyMoney is great because you as a customer never feel left behind or ignored. They keep you abreast of everything to do with your finance.',
        name: 'Martyn',
    },

    {
        rating: 5,
        text: "The level of detail you go into is unprecedented for a free service. Other free services feel like they're there to just sell you credit but TotallyMoney feels like it's here to help improve my credit.",
        name: 'Tony',
    },

    {
        rating: 5,
        text: 'Knowledge is power as has been quoted and this applies to personal finances too. TotallyMoney provides the knowledge and information to help you make the right financial decisions.',
        name: 'Edwin',
    },
]
